export const FETCH_REPORTS = 'FETCH_REPORTS'
export const FETCH_REPORT = 'FETCH_REPORT'
export const FETCH_BID = 'FETCH_BID'
export const FETCH_CURRENT_REPORT = 'FETCH_CURRENT_REPORT'
export const FETCH_RESPONSES = 'FETCH_RESPONSES'
export const FETCH_LOAD_DAYS = 'FETCH_LOAD_DAYS'
export const FETCH_ALL = 'FETCH_ALL'
export const FETCH_ACTS = 'FETCH_ACTS'
export const FETCH_PAYMENT = 'FETCH_PAYMENT'
export const FETCH_FIX_BLOCK_TTNS = 'FETCH_FIX_BLOCK_TTNS'
export const FETCH_REPORT_MODAL = 'FETCH_REPORT_MODAL'
export const SET_LOADED = 'SET_LOADED'
export const SET_LOADED_REPORTS = 'SET_LOADED_REPORTS'
export const SET_LOADED_ADD_REPORT = 'SET_LOADED_ADD_REPORT'
export const SET_LOADED_RESPONSES_NOT_ADDED = 'SET_LOADED_RESPONSES_NOT_ADDED'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_PROGRESS_BAR = 'SET_PROGRESS_BAR'
export const SET_STATUS_DOWNLOAD = 'SET_STATUS_DOWNLOAD'
export const SET_RESPONSES_NOT_ADDED = 'SET_RESPONSES_NOT_ADDED'
export const FETCH_RESPONSES_NOT_ADDED = 'FETCH_RESPONSES_NOT_ADDED'
export const ADD_RESPONSE_IN_REPORT = 'ADD_RESPONSE_IN_REPORT'
export const FETCH_TTNS = 'FETCH_TTNS'
export const SET_LOADED_TTNS = 'SET_LOADED_TTNS'
export const SET_PAGINATION = 'SET_PAGINATION'
export const REMOVE_REPORT = 'REMOVE_REPORT'
export const ADD_SELECTED_RESPONSE = 'ADD_SELECTED_RESPONSE'
export const SET_LOADED_RESPONSES = 'SET_LOADED_RESPONSES'
